import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { KontniPlan } from './kontni-plan';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-kontni-plan-modal-update',
  templateUrl: './kontni-plan-modal-update.component.html'
})
export class KontniPlanModalUpdateComponent extends BaseModalUpdateComponent<KontniPlan> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KontniPlan>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
